import {useEffect, useState} from "react";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import '../../../static/css/pages/print/print.css';
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {useParams} from "react-router-dom";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GradeToString} from "../students/list";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {TomansIcon} from "../../../components/icons/material-icons";

interface printStudentsInterface {
    id: number,
    firstname: string,
    lastname: string,
    grade: number,
    national: string,
    father: string, // name
    birthSerial: string,
    homeTell: string,
    birthDate: string,
    fatherCertificate: string,
    fatherTell: string,
    fatherJob: string,
    motherName: string,
    motherTell: string,
    motherCertificate: string,
    motherJob: string,
    zipCode: string,
    address: string,
    budget: number,
    maxBuyPerDay: number,
    IsInside: 0 | 1,
    className: string,
    classId: number,
}

export const AdminsPrintStudentByClassScreen = () => {
    const {
        classId,
        name,
        grade,
        national,
        father,
        birthSerial,
        homeTell,
        birthDate,
        fatherCertificate,
        fatherTell,
        fatherJob,
        motherName,
        motherTell,
        motherCertificate,
        motherJob,
        zipCode,
        address,
        budget,
        maxBuyPerDay,
        isInside,
        className,
    } = useParams();
    const [data, setData] = useState({
        loaded: false,
        list: [] as printStudentsInterface[],
    });
    const fetchList = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/print',
            {
                classId:classId as string,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: printStudentsInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    list: d.list === null ? [] : d.list,
                    loaded: true,
                });
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "پرینت دانش‌آموزان | نهال";
        HideMainLoading();
        fetchList();
    }, []);
    return (
        <>
            <div className="print-screen">
                <button onClick={window.print}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                        <path
                            d="M640-615.385v-120H320v120h-40v-160h400v160h-40Zm-456.923 40h593.846-593.846Zm521.538 100q17 0 28.5-11.5t11.5-28.5q0-17-11.5-28.5t-28.5-11.5q-17 0-28.5 11.5t-11.5 28.5q0 17 11.5 28.5t28.5 11.5ZM640-200v-181.538H320V-200h320Zm40 40H280v-160H143.077v-215.385q0-34 23.077-57t56.923-23h513.846q34 0 57 23t23 57V-320H680v160Zm96.923-200v-175.385q0-17-11.5-28.5t-28.5-11.5H223.077q-17 0-28.5 11.5t-11.5 28.5V-360H280v-61.539h400V-360h96.923Z"/>
                    </svg>
                    پرینت
                </button>
                <b>فهرست دانش‌آموزان</b>
                <span>دبستان مهارتی نهال</span>
                <table className="table open-table table-stripped table-bordered"
                       style={{display: 'table!important', border: 0}}>
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        {name === "1" ? <th>نام</th> : null}
                        {grade === "1" ? <th>پایه</th> : null}
                        {national === "1" ? <th>کدملی</th> : null}
                        {father === "1" ? <th>نام پدر</th> : null}
                        {birthSerial === "1" ? <th>سریال شناسنامه</th> : null}
                        {homeTell === "1" ? <th>تلفن منزل</th> : null}
                        {birthDate === "1" ? <th>تاریخ تولد</th> : null}
                        {fatherCertificate === "1" ? <th>مدرک پدر</th> : null}
                        {fatherTell === "1" ? <th>تلفن پدر</th> : null}
                        {fatherJob === "1" ? <th>شغل پدر</th> : null}
                        {motherName === "1" ? <th>نام مادر</th> : null}
                        {motherTell === "1" ? <th>تلفن مادر</th> : null}
                        {motherCertificate === "1" ? <th>مدرک مادر</th> : null}
                        {motherJob === "1" ? <th>شغل مادر</th> : null}
                        {zipCode === "1" ? <th>کد پستی</th> : null}
                        {address === "1" ? <th>آدرس</th> : null}
                        {budget === "1" ? <th>موجودی فروشگاه</th> : null}
                        {maxBuyPerDay === "1" ? <th>سقف خرید</th> : null}
                        {isInside === "1" ? <th>وضعیت حضور</th> : null}
                        {className === "1" ? <th>کلاس</th> : null}
                    </tr>
                    </thead>
                    <tbody>
                    {
                        (data.list === null ? [] : data.list).map((p, i) =>
                            <tr key={"K39E222rc1nS2" + i}>
                                <td>{StringDigitsConvertToPersian(i+1)}</td>
                                {name === "1" ? <td>{p.firstname + " " + p.lastname}</td> : null}
                                {grade === "1" ? <td>{GradeToString(p.grade)}</td> : null}
                                {national === "1" ? <td>{StringDigitsConvertToPersian(p.national)}</td> : null}
                                {father === "1" ? <td>{p.father}</td> : null}
                                {birthSerial === "1" ? <td>{StringDigitsConvertToPersian(p.birthSerial)}</td> : null}
                                {homeTell === "1" ? <td>{StringDigitsConvertToPersian(p.homeTell.replaceAll('+98','0'))}</td> : null}
                                {birthDate === "1" ? <td>{StringDigitsConvertToPersian(GregorianToPersian(p.birthDate)).replaceAll('-','/')}</td> : null}
                                {fatherCertificate === "1" ? <td>{p.fatherCertificate}</td> : null}
                                {fatherTell === "1" ? <td>{StringDigitsConvertToPersian(p.fatherTell.replaceAll('+98','0'))}</td> : null}
                                {fatherJob === "1" ? <td>{p.fatherJob}</td> : null}
                                {motherName === "1" ? <td>{p.motherName}</td> : null}
                                {motherTell === "1" ? <td>{StringDigitsConvertToPersian(p.motherTell.replaceAll('+98','0'))}</td> : null}
                                {motherCertificate === "1" ? <td>{p.motherCertificate}</td> : null}
                                {motherJob === "1" ? <td>{p.motherJob}</td> : null}
                                {zipCode === "1" ? <td>{StringDigitsConvertToPersian(p.zipCode)}</td> : null}
                                {address === "1" ? <td>{StringDigitsConvertToPersian(p.address)}</td> : null}
                                {budget === "1" ? <td><span>{CurrencyFormat(p.budget)}<TomansIcon/></span></td> : null}
                                {maxBuyPerDay === "1" ? <td>{p.maxBuyPerDay < 1 ? '-' : <span>{CurrencyFormat(p.maxBuyPerDay)}<TomansIcon/></span>}</td> : null}
                                {isInside === "1" ? <td>{p.IsInside === 1 ? 'داخل مدرسه' : 'خارج از مدرسه'}</td> : null}
                                {className === "1" ? <td>{p.classId > 0 ? StringDigitsConvertToPersian(p.className) : '-'}</td> : null}
                            </tr>
                        )
                    }
                    </tbody>
                </table>
            </div>
        </>
    );
};